<template>
  <div>
    <notifications group="notification" position="bottom right" />

    <div class="row">
      <div class="col-md-9">
        <div class="card card-custom card-sticky" id="kt_page_sticky_card">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Add New Category</h3>
            </div>
            <CardToolbar
              @submitEvent="submit"
              back-text="Back to list"
              back-url="/products-categories/list"
              button-text="Add Category"
            />
          </div>
          <div class="card-body">
            <!--begin::Form-->
            <form class="form" id="kt_form">
              <div class="form-group">
                <label for="postTitle">Title</label>
                <input
                  v-model="category.title"
                  id="categoryTitle"
                  class="form-control form-control-solid"
                  placeholder="Enter Category title"
                />
              </div>

              <div class="form-group">
                <label for="postTitle">Subtitle</label>
                <input
                  v-model="category.subtitle"
                  id="categorySubtitle"
                  class="form-control form-control-solid"
                  placeholder="Enter Category subtitle"
                />
              </div>

              <div class="form-group">
                <label for="postContent">Description</label>
                <textarea
                  v-model="category.description"
                  id="categoryDescription"
                  class="form-control form-control-solid"
                  rows="8"
                ></textarea>
              </div>
            </form>
            <!--end::Form-->
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card card-custom">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label">Options</h3>
            </div>
          </div>
          <div class="card-body">
            <div class="row flex justify-content-between">
              <label class="col-6 col-form-label font-weight-bolder"
                >Publish:</label
              >
              <MCSwitch
                @checkedEvent="toggleIsPublish"
                classes="switch-icon float-right"
                name="isPublish"
                :is-checked="category.isPublish"
              />
            </div>
            <div class="row flex justify-content-between">
              <label class="col-6 col-form-label font-weight-bolder"
                >Archived:</label
              >
              <MCSwitch
                @checkedEvent="toggleIsArchived"
                classes="switch-icon float-right"
                name="isArchived"
                :is-checked="category.isArchived"
              />
            </div>
            <div class="form-group">
              <label>Parent</label>
              <select-field
                v-model="category.parent"
                :options="rootCategories"
                label-key="title"
                :searchable="true"
                placeholder="Select category"
              >
                <template #option="{ option }">
                  <li v-if="option.parent">-- {{ option.title }}</li>
                  <li v-else>{{ option.title }}</li>
                </template>
              </select-field>
            </div>
            <div class="form-group">
              <label>Position</label>
              <input
                type="number"
                v-model.number="category.position"
                class="form-control form-control-sm form-control-solid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import CardToolbar from '@/view/content/components/card-toolbar/CardToolbar'
import ApiService from '@/core/services/api.service'
import MCSwitch from '@/view/content/components/switch/MCSwitch.vue'
import SelectField from '@/view/content/components/select-field/SelectField.vue'

export default {
  name: 'NewProductCategory',
  components: {
    SelectField,
    MCSwitch,
    CardToolbar,
  },
  data() {
    return {
      category: {
        title: null,
        subtitle: null,
        description: null,
        parent: null,
        position: null,
        isPublish: false,
        isArchived: false,
      },
      categories: [],
      rootCategories: [],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'All Categories', route: '/categories/list' },
      { title: 'Add New' },
    ])

    this.getCategories(
      '/product_categories',
      '?order[createdAt]=desc&itemsPerPage=90'
    ).then(({ data }) => {
      this.categories = [...data['hydra:member']]
      this.categories.forEach((category) => {
        if (category.parent === undefined) {
          this.rootCategories.push(category)
        }
      })
    })
  },
  methods: {
    async submit() {
      this.postCategory(this.category)
        .then(() => {
          this.$notify({
            group: 'notification',
            type: 'success',
            title: 'Category success added',
          })

          setTimeout(() => {
            this.$router.push({ name: 'products-categories-list' })
          }, 500)
        })
        .catch(() => {
          this.$notify({
            group: 'notification',
            type: 'error',
            title: 'Category error',
          })
        })
    },
    async postCategory(entity) {
      return await ApiService.post('/product_categories', entity)
    },
    async getCategories(resource, slug = '') {
      try {
        return await ApiService.get(resource, slug)
      } catch (e) {
        throw new Error(e)
      }
    },
    toggleIsPublish() {
      this.category.isPublish = !this.category.isPublish
    },
    toggleIsArchived() {
      this.category.isArchived = !this.category.isArchived
      this.category.isPublish = false
    },
  },
}
</script>
